import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from "@mui/material";
var FilterAccordion = function (_a) {
    var title = _a.title, _b = _a.defaultExpanded, defaultExpanded = _b === void 0 ? true : _b, children = _a.children;
    return (_jsx(Box, { sx: { width: "100%" }, children: _jsxs(Accordion, { defaultExpanded: defaultExpanded, disableGutters: true, sx: {
                width: "100%",
                fontFamily: "var(--default-font)",
                bgcolor: "transparent",
                boxShadow: "none",
                borderRadius: 2,
                overflow: "hidden",
                "&:before": { display: "none" },
                border: "1px solid rgba(255,255,255,0.12)",
                transition: "border-color 300ms ease, background-color 300ms ease",
                "&:hover": {
                    borderColor: "var(--accent-border)",
                    bgcolor: "rgba(255,255,255,0.06)",
                },
                "&.Mui-expanded": {
                    margin: 0,
                    borderColor: "rgba(255,255,255,0.2)",
                    bgcolor: "rgba(255,255,255,0.06)",
                },
                "&.Mui-expanded:hover": {
                    margin: 0,
                    borderColor: "var(--accent-border)",
                    bgcolor: "rgba(255,255,255,0.06)",
                },
            }, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ArrowDropDownIcon, {}), sx: {
                        px: 1.25,
                        py: 0.75,
                        minHeight: 44,
                        color: "rgba(255,255,255,0.95)",
                        "&.Mui-expanded": {
                            minHeight: 44,
                        },
                        "& .MuiAccordionSummary-content": {
                            margin: 0,
                            alignItems: "center",
                            "&.Mui-expanded": { margin: 0 },
                        },
                        "& .MuiAccordionSummary-expandIconWrapper": {
                            color: "rgba(255,255,255,0.7)",
                            transition: "transform 150ms ease, color 150ms ease",
                            "&.Mui-expanded": {
                                transform: "rotate(180deg)",
                            },
                        },
                        "&:hover .MuiAccordionSummary-expandIconWrapper": {
                            color: "rgba(255,255,255,0.9)",
                        },
                    }, children: _jsx(Typography, { component: "span", sx: {
                            fontFamily: "var(--default-font)",
                            fontSize: 14,
                            fontWeight: 600,
                            letterSpacing: "0.2px",
                        }, children: title }) }), _jsx(AccordionDetails, { sx: {
                        px: 1.25,
                        pt: 0.5,
                        pb: 1.25,
                        borderTop: "1px solid",
                        borderColor: "rgba(255,255,255,0.08)",
                    }, children: children })] }) }));
};
export default FilterAccordion;
